import { QueryMethods } from '../../enums/query-methods.enums';
import { GetQuery } from '../../@types/rtk-query';
import { GetAvailablePlansRequest } from '../account/dto/request/get-available-plans.request';
import { ROUTES } from './account-plan.consts';

export const getAvailablePlansQuery = (
  params: GetAvailablePlansRequest,
): GetQuery => ({
  url: ROUTES.AVAILABLE_PLANS,
  method: QueryMethods.Get,
  params,
});
